// The Inbox's Calls and Texts and email (BL-132): two tabs of one page in Blueprint, each still its own
// place with its own address (#/calls, #/messages), so links and bookmarks keep opening the one they
// named. What each tab's count says, kept out of the component so it's tested without a browser.

import { countLabel } from '../calls/callbacks-model.ts';

export type TalkView = 'calls' | 'messages';

/** The two tabs, in order, by the names the rail gives them. */
export const TALK_TABS: readonly { view: TalkView; label: string }[] = [
  { view: 'calls', label: 'Calls' },
  { view: 'messages', label: 'Texts and email' },
];

/** What waits on each: calls ringing while away from Calls, calls to call back, replies no one has opened. */
export interface TalkWaiting {
  ringing: number;
  callbacks: number;
  replies: number;
}

/**
 * A tab's count, and the words a screen reader hears after it: on Calls, a call ringing while you're
 * elsewhere ("1 ringing", as the rail counts it), else the calls still to call back ("3 to call back",
 * the callback queue's); on Texts and email, the new replies ("2 new replies"). Nothing at zero.
 */
export function talkCount(view: TalkView, w: TalkWaiting): { n: number; words: string } | null {
  if (view === 'calls') {
    if (w.ringing > 0) return { n: w.ringing, words: `${w.ringing} ringing` };
    return w.callbacks > 0 ? { n: w.callbacks, words: countLabel(w.callbacks) } : null;
  }
  if (w.replies <= 0) return null;
  return { n: w.replies, words: w.replies === 1 ? '1 new reply' : `${w.replies} new replies` };
}
